<template>

    <div>
        <div  class="form-group row align-items-center">
            <label class="col-form-label text-md-right col-md-2">Тип звіту</label>
            <div class="col-md-9">
                <multiselect
                    v-model="type_report"
                    label="title"
                    track-by="id"
                    :options="options_type_reports"
                    :multiple="false"
                    open-direction="bottom">
                </multiselect>
            </div>
        </div>

        <teacher-reports-visiting-missing-students-component
            :groups="groups"
            :start="start"
            :end="end"
            v-if="type_report && type_report.value === 0"
        >
        </teacher-reports-visiting-missing-students-component>
        <teacher-reports-students-searning-sap-component
            :groups="groups"
            v-if="type_report && type_report.value === 1"
        >
        </teacher-reports-students-searning-sap-component>
        <teacher-reports-average-score-component
            :groups="groups"
            v-if="type_report && type_report.value === 2"
        >
        </teacher-reports-average-score-component>
    </div>

</template>

<style scoped>
    .form-group {
        margin-bottom: 11px;
    }
    button {
        margin-right: 10px;
    }
</style>

<script>
export default {
    name: "TeacherReportsComponent",
    props: ['groups', 'start', 'end'],
    data() {
        return {
            type_report: '',
            options_type_reports: [
                { title: 'Відвідування / пропуски студентів', value: 0 },
                { title: 'Студенти з відставанням по програмі', value: 1 },
                { title: 'Студенти з середнім балом', value: 2 }
                ]
        }
    },
    computed:{
    },
    mounted() {
    },
    methods: {
    }
}
</script>
